import { render, staticRenderFns } from "./EditRow.vue?vue&type=template&id=90fb9412&scoped=true"
import script from "./EditRow.vue?vue&type=script&lang=ts"
export * from "./EditRow.vue?vue&type=script&lang=ts"
import style0 from "./EditRow.vue?vue&type=style&index=0&id=90fb9412&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fb9412",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90fb9412')) {
      api.createRecord('90fb9412', component.options)
    } else {
      api.reload('90fb9412', component.options)
    }
    module.hot.accept("./EditRow.vue?vue&type=template&id=90fb9412&scoped=true", function () {
      api.rerender('90fb9412', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stock/EditRow.vue"
export default component.exports